import { render, staticRenderFns } from "./FarmOrder.vue?vue&type=template&id=a89c955a&scoped=true"
import script from "./FarmOrder.vue?vue&type=script&lang=js"
export * from "./FarmOrder.vue?vue&type=script&lang=js"
import style0 from "./FarmOrder.vue?vue&type=style&index=0&id=a89c955a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89c955a",
  null
  
)

export default component.exports